import { ComponentResource, ProductResource, ProductVariantResource } from '@/api/serverApi'
import { RootState } from '@/stores'
import { useSelector } from 'react-redux'

export interface useComponentProductResult {
  product: ProductResource | null
  productVariant: ProductVariantResource | null
}

type PropTypes = {
  component?: ComponentResource
}

const useComponentProduct = ({ component }: PropTypes): useComponentProductResult => {
  const products = useSelector((state: RootState) => state.products.products)
  const productVariants = useSelector((state: RootState) => state.products.productVariants)

  const productVariant = component ? productVariants?.find(c => c.id === component.product_variant_id) ?? null : null
  const product = productVariant?.product_id ? products.find(p => p.id === productVariant.product_id) ?? null : null

  return {
    product: product,
    productVariant: productVariant,
  }
}

export default useComponentProduct
